import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { StyledStack, StyledTitle, ButtonContainer } from "./Cart.style";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { getCmessageRequest, updateCmessageRequest } from "api/requests";
import { privacySchema } from "validations";

export default function AddCartMessage() {
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(privacySchema),
  });

  const onSubmit = async (values) => {
    const res = await request({
      url: updateCmessageRequest,
      values,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش متن سبد خرید",
      });
    }
  };

  const getCartMessage = useCallback(async () => {
    let res = await request({
      url: () => getCmessageRequest(),
    });

    if (res) {
      reset({
        text: res.text,
      });
    }
  }, [request, reset]);

  useEffect(() => {
    getCartMessage();
  }, [getCartMessage]);

  return (
    <DrawerCM title="متن سبد خرید">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <StyledStack>
            <StyledTitle>متن سبد خرید</StyledTitle>
            <Grid container>
              <Grid item xs={12} p={1.2}>
                <TextField
                  id="text"
                  label="متن سبد خرید"
                  variant="outlined"
                  multiline
                  rows={6.3}
                  fullWidth
                  required
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helpertext={errors.text?.message}
                />
              </Grid>

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
